import { Box, Paper, Typography } from "@mui/material";

interface CancelCauseBlockProps {
  text: string;
}

export function CancelCauseBlock({ text }: CancelCauseBlockProps) {
  return (
    <Box sx={{ mt: 3 }}>
      <Paper sx={{ padding: "1rem", borderRadius: "1rem" }} elevation={0}>
        <Box display="flex" flexDirection="column">
          <Typography variant="subtitle2" fontWeight="bold" color="black">
            Причина отмены
          </Typography>
          <Typography variant="subtitle2" fontWeight="bold" color="black">
            {text}
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
}
